export const BASE_URL = "https://api.skipthedm.com/api/v1";

export const routes = {
  // -----AUTH------//
  signUp: BASE_URL + "/user/signup",
  signIn: BASE_URL + "/users/login",
  logOut: BASE_URL + "/user/logout",

  // -----Admin Dashboard------//
  adminDashboard: BASE_URL + "/admin/dashboard",

  // -----------Users--------------//
  getAllUsers: BASE_URL + "/users",
  deleteUser: BASE_URL + "/users",
  getAdminVendors: BASE_URL + "/admin/vendors",
  getAdminVendorById: BASE_URL + "/admin/vendors",
  getAdminCustomers: BASE_URL + "/admin/customers",
  setUserActiveStatus: BASE_URL + "/admin/users",
  // -------------products-------------//
  getAllProducts: BASE_URL + "/products/admin",
  deleteProduct: BASE_URL + "/products/admin",
  // -------------shops-------------//
  getAllShops: BASE_URL + "/users?role=vendor",

  // -------------Admin orders and finance-------------//
  getAdminOrders: BASE_URL + "/admin/orders",
  getAdminOrderById: BASE_URL + "/admin/orders",
  getAdminMonnifyTransactions: BASE_URL + "/admin/monnify/transactions",
  getAdminPlatformFees: BASE_URL + "/admin/platform-fees",

  // -------------Size-Variant-------------//
  sizeVariant: BASE_URL + "/variant-sizes",
  // -------------Color-Variant-------------//
  colorVariant: BASE_URL + "/variant-colors",
  // -------------Content-------------//
  termsConditions:
    BASE_URL + "/termsandcondition/get-one-term/68dd750e1342f027b680680a",
  updateTerms:
    BASE_URL + "/termsandcondition/update-terms/68dd750e1342f027b680680a",
  privacyPolicy: BASE_URL + "/privacy/get-one-policy/68dd759a1342f027b680681c",
  updatePrivacy: BASE_URL + "/privacy/update-policy/68dd759a1342f027b680681c",
};
